import styled from 'styled-components';

import { Badge } from '../Badge';

export const CardBadge = styled(Badge)`
    position: absolute;
`;
